import { GW4BleMessage } from './gw4BleMessage';
import { Ack, AckType } from './payloads/incoming/ack';
import { AvailableNetworksType, AvailableNetworks } from './payloads/incoming/availableNetworks';
import { Info, InfoPayloadType } from './payloads/incoming/info';
import { Status, StatusType } from './payloads/incoming/status';
import { SyncProgress, SyncProgressType } from './payloads/incoming/syncProgress';
import { Payload } from './payloads/payload';

export const GW4BLEIncomingMessageType = 0x0500;

export class GW4BleIncomingMessage extends GW4BleMessage {
  constructor(serialNumber: number) {
    super(serialNumber, GW4BLEIncomingMessageType);
  }
}

Payload.Register(AckType, Ack);
Payload.Register(AvailableNetworksType, AvailableNetworks);
Payload.Register(InfoPayloadType, Info);
Payload.Register(StatusType, Status);
Payload.Register(SyncProgressType, SyncProgress);
